import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import {
  assertUnreachable,
  JobStatusSchema,
  PartTypeSchema,
  PredictionModelTypeSchema,
  PredictionModelTypeType,
} from "shared";

const hasGraphError = (part: QuoteRequestLineDto["part"]) =>
  part.graphStatus === JobStatusSchema.enum.ERROR;

const hasEmbeddingError = (part: QuoteRequestLineDto["part"]) =>
  part.embeddingStatus === JobStatusSchema.enum.ERROR;

export const hasFeaturesDetectionError = (
  modelType: PredictionModelTypeType | null,
  part: QuoteRequestLineDto["part"],
): boolean => {
  if (!modelType) {
    return false;
  }

  if (part.type === PartTypeSchema.enum.MACHINING) {
    return hasGraphError(part);
  }

  switch (modelType) {
    case PredictionModelTypeSchema.enum.V2:
    case PredictionModelTypeSchema.enum.MULTI_MODAL:
      return hasGraphError(part);
    case PredictionModelTypeSchema.enum.CLUSTERING:
      return hasEmbeddingError(part);

    default:
      assertUnreachable(modelType);
  }
};
